import { createGetHistoryStackEntryAtOffsetSelector } from '../../history-stack';
import { getAdminPanelsHistory } from './get-admin-panels-history';

export const getPreviousAdminPanelsHistoryEntry = createGetHistoryStackEntryAtOffsetSelector(
  getAdminPanelsHistory,
  -1,
);
